import ActionType from './ActionType';
import axios from 'axios';


const createPolicyTypeAction=(policyTypeJson)=>{
    return {
        type:ActionType.FETCH_POLICY_TYPE,
        data:policyTypeJson.list,
    }
}

export const fetch_policy_type=(method,params)=>{
    return (dispatch)=>{
        axios({
            url:'/api/PolicyCate',
            method:method,
            params:params,
            headers:{
                'Content-Type':'application/json;charset=utf8',
            }
        }).then((response)=>{
            dispatch(createPolicyTypeAction(response.data.data));
        }).catch((error)=>{
            console.log(error);
        })
    }
}